module.exports = __webpack_public_path__ + "img/storm.cd1e63fc.jpg";